/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/home/desktop/theatersModule.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'home/desktop/theatersModule', exports: {} };
const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from '@take-2/fd-modules/splits/require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import $ from '@take-2/fd-modules/jQuery';



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { fd_url_manager as links } from '@take-2/fd-modules/splits/require-core';



import { swig as swig } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';



import { fd_location as fd_location_updateLocation_getLocation } from '@take-2/fd-modules/splits/require-global';

const { updateLocation, getLocation } = fd_location_updateLocation_getLocation;


import { fd_location_form_creation as locationFormCreation } from '@take-2/fd-modules/splits/require-global';



import shared_utils_urlHelpers_generateTspLink from '@take-2/fd-modules/shared/utils/urlHelpers';

const { generateTspLink } = shared_utils_urlHelpers_generateTspLink;


const Selectors = Object.freeze({
    LOCATION: '#theaters-module-location',
    MODULE_WRAP: '#theater-module-wrap',
    SEE_MORE_THEATERS: '#theaters-module-see-more',
    THEATER_ITEM: '.js-theaters-module-theater',
    THEATERS_PLACEHOLDER: '#theater-module-placeholder',
})


const Styles = Object.freeze({
    HIDE: 'hide',
    SELECTED: 'theaters-module__theater-link--selected',
    THEATERS_ONLY: 'theaters-module--theaters-only',
})
function onTheaterClick() {
    const { id } = this.dataset;
    track({
        event: EventTypes.THEATER_MODULE_THEATER_CLICKED,
        id,
    });
}
function onLocationChange() {
    $(Selectors.THEATERS_PLACEHOLDER).html(swig.render('_theatersModuleCardsPlaceholder'));
    init();
}
function onDone(data) {
    if (data.error || !Array.isArray(data.theaters)) {
        onFail(data.error);
        return;
    }
    const $theatersPlaceholder = $(Selectors.THEATERS_PLACEHOLDER);
    const markup = swig.render('_theatersModule', data);
    $theatersPlaceholder.html(markup);
    $(Selectors.THEATER_ITEM, $theatersPlaceholder).on('click', onTheaterClick);
}
function onFail(err) {
    debugLog.error(module.name, 'API Fail', err);
    $(Selectors.MOVIES_PLACEHOLDER).html('');
    $(Selectors.THEATERS_PLACEHOLDER).html(swig.render('_errorMessage', {
        msg: 'There was an error retrieving nearby theaters.'
    }));
}
function init() {
    debugLog.log(module.name, 'init');
    $(Selectors.MODULE_WRAP)
        .addClass(Styles.THEATERS_ONLY)
        .removeClass(Styles.HIDE);
    const location = getLocation();
    updateLocation(location);
    locationFormCreation.init({
        trigger: `${Selectors.LOCATION} .js-location-overlay`,
        dropdown: {
            name: 'desktopHomeNearTheatersModule',
            relativeParent: Selectors.LOCATION,
        }
    });
    const [city, state] = location?.name?.split(', ') || [];
    let locationParam;
    if (location.zip) {
        locationParam = location.zip;
    }
    else if (city && state) {
        locationParam = `${city.replace(/\s/, '-').toLowerCase()}_${state.toLowerCase()}`;
    }
    if (locationParam) {
        $(Selectors.SEE_MORE_THEATERS).attr('href', generateTspLink(locationParam));
    }
    locationFormCreation.attach(onLocationChange);
    xhr.ajax({
        url: links.napiHomeTheaterModule(null, {
            ...location?.params,
        }),
        method: 'GET'
    })
        .done(onDone)
        .fail(onFail);
}
export default {
    init,
};
